import type { ExplorerSelection } from "@/features/explorer/types";

/**
 * Merges a partial selection update into the current selection.
 *
 * Any update that switches the data context (metric, statistic, or geography)
 * resets the period to "latest" unless the update explicitly targets the
 * period, because the new context may not share the same time series as the
 * previous one. Without this, a metric swap would carry over a stale period
 * (e.g. `2019-02-01`) that the newly selected dataset has no rows for, leaving
 * the map silently empty.
 */
export function resolveSelectionUpdate(
  current: ExplorerSelection,
  next: Partial<ExplorerSelection>,
): ExplorerSelection {
  const merged = { ...current, ...next };

  const changesContext =
    next.metricId !== undefined || next.statisticId !== undefined || next.geographyLevel !== undefined;

  if (changesContext && next.period === undefined) {
    merged.period = "latest";
  }

  return merged;
}
